







































import { Input, InputLabel, AltInputLabel, InputError, CustomLink } from '../../atoms'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { PASSWORD_FIELD_LIMIT } from '../../../utils/field-length'
import { showForgotPasswordError, accountLockedError, CHALLENGE_EXPIRED, wrongPasswordError } from '../../../utils/errors'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    Input,
    InputLabel,
    AltInputLabel,
    InputError,
    CustomLink
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
})
export default class PasswordInputGroup extends Vue {
  @Prop({ required: true, type: String }) readonly value!: string
  @Prop({ type: String, default: 'password' }) readonly type?: string
  @Prop({ type: String, default: '' }) readonly name?: string
  @Prop({ type: String, default: '' }) readonly id?: string
  @Prop({ type: String, default: '' }) readonly inputFor?: string
  @Prop({ type: String, default: '' }) readonly error?: string
  @Prop({ type: Boolean, default: false }) readonly disableAltLabel?: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled?: boolean
  @Prop({ type: String, default: false }) readonly label?: string

  @Watch('error')
  onErrorChange(error: string) {
    if (error === CHALLENGE_EXPIRED) {
      setTimeout(() => {
        const baseURL = process.env.VUE_APP_FINNO_ENDPOINT || ''
        location.href = baseURL
      }, 1000)
    }
  }

  get showForgotPasswordPrompt(): boolean {
    return this.error === showForgotPasswordError
  }
  get showAccountLockedPrompt(): boolean {
    return this.error === accountLockedError
  }
  get showWrongPasswordPrompt(): boolean {
    return this.error === wrongPasswordError
  }
  goToForgotPassword() {
    this.$router.push({ path: '/forgot-password', query: { email: this.$route?.query?.email } })
  }
  get passwordFieldLimit(): number {
    return PASSWORD_FIELD_LIMIT
  }
}
